export default __webpack_public_path__ + "static/media/jobshub-02-v1.22fc5819.jpg";